import React from 'react';
import FormSection from './FormSection';
import { Input } from '../common';
import Select from '../common/Select';
import { 
  FREQUENCY_OPTIONS, 
  AUDITOR_ORG_OPTIONS, 
  PURPOSE_OPTIONS 
} from './constants';

const BasicAuditInfo = ({ formData, onChange, errors = {} }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    // Clear error for the field if it has a value
    const updatedData = { [name]: value };
    const updatedErrors = { ...errors };
    
    if (value) {
      delete updatedErrors[name];
      onChange(updatedData, updatedErrors);
    } else {
      onChange(updatedData);
    }
  };

  return (
    <FormSection title="Basic Audit Information" defaultExpanded={true}>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <Select
          label="Frequency"
          name="frequency"
          value={formData.frequency}
          onChange={handleInputChange}
          options={FREQUENCY_OPTIONS}
          error={errors.frequency}
          required
        />

        <Input
          label="Activity Last Performed"
          name="activityLastPerformed"
          type="date"
          value={formData.activityLastPerformed}
          onChange={handleInputChange}
          error={errors.activityLastPerformed}
        />

        <Input
          label="Due Date"
          name="dueDate"
          type="date"
          value={formData.dueDate}
          onChange={handleInputChange}
          error={errors.dueDate}
          required
        />

        <Select
          label="Auditor Organization"
          name="auditorOrg"
          value={formData.auditorOrg}
          onChange={handleInputChange}
          options={AUDITOR_ORG_OPTIONS}
          error={errors.auditorOrg}
          required
        />

        <Select
          label="Purpose"
          name="purpose"
          value={formData.purpose}
          onChange={handleInputChange}
          options={PURPOSE_OPTIONS}
          error={errors.purpose}
          required
        />
      </div>
    </FormSection>
  );
};

export default BasicAuditInfo;
